import React from "react";

const ShippingPolicy = () => {
    return (
        <div className="policy-container">
            <h1>Shipping & Delivery Policy</h1>

            <p>
                At <strong>ONLINE INDIA COMPUTER AND LAPTOP SHOP</strong>, we strive to provide fast, reliable, and transparent shipping across India. Please review the following terms to understand how your order will be processed and delivered.
            </p>

            <h2>1. Order Processing</h2>
            <p>
                Orders are processed within <strong>1–2 business days</strong> of payment confirmation. Orders placed on weekends or public holidays will be processed on the next working day.
            </p>

            <h2>2. Shipping Coverage</h2>
            <p>
                We ship to most locations across India. If your location is outside our delivery range, we will inform you and cancel the order if necessary.
            </p>

            <h2>3. Estimated Delivery Time</h2>
            <ul>
                <li><strong>Metro Cities:</strong> 2–5 business days</li>
                <li><strong>Other Cities/Towns:</strong> 4–7 business days</li>
                <li><strong>Remote Areas:</strong> Up to 10 business days</li>
            </ul>
            <p>
                Note: Delivery times may vary based on courier service availability and unforeseen delays.
            </p>

            <h2>4. Shipping Charges</h2>
            <p>
                Shipping costs are based on weight, size, and destination. Exact shipping fees will be displayed at checkout before confirming your order.
            </p>

            <h2>5. Tracking Your Order</h2>
            <p>
                Once your package is shipped, a tracking ID will be sent via email/SMS. You can use this to track the shipment on the courier’s website.
            </p>

            <h2>6. Delays & Exceptions</h2>
            <p>
                In rare cases, delivery may be delayed due to weather, strikes, or logistical issues. We appreciate your patience and will do our best to update you promptly.
            </p>

            <h2>7. Damaged or Lost Shipments</h2>
            <p>
                If your package is tampered with or arrives damaged, please refuse delivery and contact us at <b>onlineindiakunal@gmail.com</b> immediately. For lost shipments, we will initiate a courier investigation and offer a replacement or refund based on the outcome.
            </p>

            <h2>8. Address Modification</h2>
            <p>
                If you need to change your delivery address after placing an order, please contact us as soon as possible. Address changes are not guaranteed once the shipment is dispatched.
            </p>

            <h2>9. Customer Support</h2>
            <p>
                For any queries regarding shipping, feel free to reach out to us at <b>onlineindiakunal@gmail.com</b>. Our team is here to assist you.
            </p>
        </div>
    );
};

export default ShippingPolicy;
